<style>

    html, body {
        position: relative;
        height: 100%;
        font-size: 12px;
    }

    .swiper-container {
        width: 100%;
        height: 100%;
    }

    body:after {
        background-image: url('../imgs/culture/gbwh_bg.jpg'); background-repeat: no-repeat; background-size: cover;
    }

    /*
     * pan_height_line1
     */

    .pan_height_line1_zh {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line1_zh {
            height: 360px;
            /*height: 355px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line1_zh {
            height: 340px;
            /*height: 315px;*/
        }
    }

    .pan_height_line1_en {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line1_en {
            height: 360px;
            /*height: 415px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line1_en {
            height: 340px;
            /*height: 370px;*/
        }
    }

    /*
     * pan_height_line2
     */

    .pan_height_line2_zh {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line2_zh {
            height: 220px;
            /*height: 294px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line2_zh {
            height: 220px;
            /*height: 306px;*/
        }
    }

    .pan_height_line2_en {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line2_en {
            height: 220px;
            /*height: 355px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line2_en {
            height: 220px;
            /*height: 346px;*/
        }
    }

    .container-margin-bottom {
        margin-bottom: 10px;
    }
    @media (min-width: 768px) {
        .container-margin-bottom {
            margin-bottom: 60px;
        }
    }

    .pan-num {
        text-align: center;
        font-size: 80px;
        /*color: #F29700;*/
        color: #D3A571;
        padding-left: 20px;
        padding-top: 25px;
    }
    @media (min-width: 768px) {
        .pan-num {
            font-size: 144px;
            padding-top: 0;
        }
    }

    .pan-num-size {
        width: 80px;
    }

    @media (min-width: 768px) {
        .pan-num-size {
            width: 130px;
        }
    }

    @media (min-width: 992px) {
        .pan-num-size {
            width: 130px;
        }
    }

    @media (min-width: 1200px) {
        .pan-num-size {
            width: 150px;
        }
    }

    .pan-01-wrapper {
        padding: 0px 0px 30px 0px;
    }

    @media (min-width: 768px) {
        .pan-01-wrapper {
            padding: 0px 0px 30px 0px;
        }
    }

    @media (min-width: 992px) {
        .pan-01-wrapper {
            padding: 0px 45px 30px 0px;
        }
    }

    @media (min-width: 1200px) {
        .pan-01-wrapper {
            padding: 0px 45px 30px 0px;
        }
    }

    .pan-01 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_01_bg.png");
        background-position-x: right;
        background-position-y: top;
        background-repeat:no-repeat;
        background-size: 20% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-01 {
            background-size: 15% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-01 {
            background-size: 30% auto;
        }
    }

    .pan-01b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-01b-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-01b-size {
            width: 70%;
        }
    }

    .pan-01-detail-size {
        width: 85%;
    }
    @media (min-width: 768px) {
        .pan-01-detail-size {
            width: 85%;
        }
    }
    @media (min-width: 992px) {
        .pan-01-detail-size {
            width: 70%;
        }
    }

    .pan-02-wrapper {
        padding: 0px 0px 30px 0px;
    }

    .pan-02 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_02_bg.png");
        background-position-x: right;
        background-position-y: bottom;
        background-repeat:no-repeat;
        background-size: 20% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-02 {
            background-size: 20% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-02 {
            background-size: 28%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02 {
            background-size: auto;
        }
    }


    .pan-02b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-02b-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-02b-size {
            width: 65%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02b-size {
            width: 60%;
        }
    }

    .pan-02-detail-size {
        width: 85%;
    }
    @media (min-width: 768px) {
        .pan-02-detail-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-02-detail-size {
            width: 68%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02-detail-size {
            width: 65%;
        }
    }

    /*
    ***************     pan-03
    */


    .pan-03-wrapper {
        padding: 0px 0px 30px 0px;
    }
    @media (min-width: 768px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
        }
    }

    @media (min-width: 992px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
            /*padding: 0px 45px 30px 0px;*/
        }
    }

    @media (min-width: 1200px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
            /*padding: 0px 45px 30px 0px;*/
        }
    }



    .pan-03 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_03_bg.png");
        background-position-x: right;
        background-position-y: bottom;
        background-repeat:no-repeat;
        background-size: 25% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-03 {
            background-size: 28% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-03 {
            background-size: 31% auto;
        }
    }
    @media (min-width: 1200px) {
        .pan-03 {
            background-size: 33% auto;
        }
    }


    .pan-03b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-03b-size {
            width: 75%;
        }
    }
    @media (min-width: 992px) {
        .pan-03b-size {
            width: 75%;
        }
    }
    @media (min-width: 1200px) {
        .pan-03b-size {
            width: 80%;
        }
    }

    .pan-03-detail-size {
        width: 80%;
    }
    @media (min-width: 768px) {
        .pan-03-detail-size {
            width: 70%;
        }
    }
    @media (min-width: 992px) {
        .pan-03-detail-size {
            width: 70%;
        }
    }
    @media (min-width: 1200px) {
        .pan-03-detail-size {
            width: 65%;
        }
    }

    .pan-04-wrapper {
        padding: 0px 0px 30px 0px;
    }

    .pan-04 {
        background: RGBA(0,0,0,0.5);
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    .content-style {
        background-color: #fff;
        margin: 0;
        padding: 20px;
    }
    @media (min-width: 768px) {
        .content-style {
            background-color: #FFFFFF;
            margin: 0 20px 80px 20px;
            padding: 20px 25px 20px 25px;
        }
    }
    .item-padding {
        height: 893px;
        padding: 0 0 0 0;
    }
    @media (min-width: 768px) {
        .item-padding {
            padding: 0 25px 0 25px;
        }
    }
    .content-style img{ display: block; width: 100%; margin-bottom: 20px;}
    .content-style h3{ display: block; margin-top: 30px; margin-bottom: 10px; color: #D3A571; text-indent: -10px;}
    .content-style P{ font-size: 16px; text-align: justify;}
    .content-style video{ margin: 20px 0;}
    .content-style .text_a{ display: inline-block; padding: 4px 10px; margin-top: 10px; background-color: rgba(255, 192, 0, 1); color: #222; font-size: 16px; line-height: normal;}
    @media (max-width: 992px) {
        .tx-page-title{ margin-left:0px;margin-right:0px;}
    }
</style>

<template>
    <div class="container container-margin-bottom">
        <div class="tx-page-title">戈壁徒步</div>
        <!--正文内容-->
        <div class="container-fluid content-style">
            <video width="100%" controls="controls" preload="none" poster="imgs/culture/gbwh_img1.jpg">
                <source src="imgs/culture/gbwh_mp42.mp4" type="video/mp4">
                很抱歉，您的浏览器不支持观看此视频。
            </video>
            <img src="">
            <h3>【玄奘之路】</h3>
            <p>大唐贞观年间，玄奘法师由古丝绸之路经中亚往印度取经、讲学，历时19年，行程5万余里，途经110多个国家。他带回了大昼佛教经典，写就了《大唐西域记》，主持译经1335 卷，远绍如来，近光遗法。</p>
            <p>1300年前，玄奘法师在这里经历追杀、背弃、迷路、彷徨、生死......最终立下铮铮誓言∶ "宁可就西而死，岂能归东而生"， 五天四夜滴水未进几将殒绝，但依然心无所惧一往无前， 最终实现了从坚持到超越的伟大升华。</p>
            <p>玄奘西行之路1万多公里，行走在这里，沿途会经过草地、丘陵、 河道、沙漠、梭林。在这里，与你同行的不止眼前的同伴，还有远古的生命和早期的圣贤。</p>
            <p>行走在历史的时空里，去对话这片土地上风沙烈日曾经触及过的生命。</p>
            <h3>【戈壁精神】</h3>
            <p>玄奘法师迎难而上及坚持不懈的取经精神与同熙精神“做对的事，做难的事，做需要时间沉淀的事”高度契合，每位同熙人都应具备永不言弃的戈壁精神。因此，自2022年起同熙商业正式开展【戈壁远征110公里四天三晚徒步挑战】，将于每年挑选优秀的员工代表参与，一同完成戈壁徒步的极限考验及自我超越。</p>
            <h3>【熙一 · 2022】</h3>
            <p>出行时间：2022年9月6日—11日</p>
            <p>出行人数：10人</p>
            <p>徒步主题：风里劲闯，不息自强</p>
            <video width="100%" controls="controls" preload="none" poster="imgs/culture/gbwh_mp4bg.jpg">
                <source src="imgs/culture/gbwh_mp4.mp4" type="video/mp4">
                很抱歉，您的浏览器不支持观看此视频。
            </video>
            <p>如果一个团队，具备了清晰的目标、吃苦的准备、坚忍的意志、互助的品格、奋进的精神，定能披荆斩棘、勇立潮头。未来，所有同熙人将带着这股戈壁精神勇往直前，克服万难，抵达胜利的终点！</p>
            <a class="text_a" href="https://mp.weixin.qq.com/s/Ws7en9GNBKRI0eMBe05BEg" target="_blank">了解更多</a>
            <h3>【熙二 · 2023】</h3>
            <p>出行时间：2023年9月9日—14日</p>
            <p>出行人数：10人</p>
            <p>徒步主题：无畏无惧，奋勇向前</p>
            <video width="100%" controls="controls" preload="none" poster="imgs/culture/gbwh_mp4bg2.jpg">
                <source src="imgs/culture/gbwh_mp4_2.mp4" type="video/mp4">
                很抱歉，您的浏览器不支持观看此视频。
            </video>
            <p>“逆境和挑战只要能激发起生命的力度，我们的成就是可以超乎自己所想象的”。戈壁是一条由勇气、信念、坚持浇铸而成的文化传承之路，也是锻炼同熙人坚强意志之路。熙军用乐观向上的心态，永不言弃的毅力，团结协助的品质去面对和战胜一切困难。无畏无惧，奋勇向前！</p>
            <a class="text_a" href="https://mp.weixin.qq.com/s/LV5MB3MYNpOYrOjvs4Y7sg" target="_blank">了解更多</a>
        </div>
    </div>
</template>
<script>

    module.exports = {
        computed: {
            pan_height_line1: function () {
                return {
                    pan_height_line1_zh: this.$i18n.locale != 'en_US',
                    pan_height_line1_en: this.$i18n.locale == 'en_US',
                }
            },
            pan_height_line2: function () {
                return {
                    pan_height_line2_zh: this.$i18n.locale != 'en_US',
                    pan_height_line2_en: this.$i18n.locale == 'en_US',
                }
            }
        },
        mounted: function () {

            $('#fundCert').viewer({
                scalable: false,
                navbar: false,
                title: false,
                toolbar: false,
                url: 'data-original'
            });
            window.pageTitle = {
                en_US: this.$i18n.messages.en_US.page_title_culture,
                zh_HK: this.$i18n.messages.zh_HK.page_title_culture,
                zh_CN: this.$i18n.messages.zh_CN.page_title_culture
            };
            window.setTitle(window.pageTitle[this.$i18n.locale]);
        }

    };

</script>


// WEBPACK FOOTER //
// culture.vue?06950ab7